import { TimeInput as NextTimeInput } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const TimeInput = withFormComponent(NextTimeInput); 